import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
is_country_fp = false;
  constructor(private router: Router) { }
  ngOnInit() {
      var currentUserId = JSON.parse(localStorage.getItem('currentUserId'));
      if(currentUserId)
      this.is_country_fp = currentUserId.country_focal_point;
  }
  introButtonClick(){
  	this.router.navigateByUrl('/introduction/intro-home')
    $(".header_active").removeClass("header_active")
    $(".intro-intro").addClass("header_active")
  }
  overviewButtonClick(){
    $(".header_active").removeClass("header_active")
    $(".intro-overview").addClass("header_active")
  	this.router.navigateByUrl('/introduction/overview')
  }
  summaryButtonClick(){
    $(".header_active").removeClass("header_active")
    $(".intro-summary").addClass("header_active")
  	this.router.navigateByUrl('/introduction/summary')
  }
  fourElementButtonClick(){
    $(".header_active").removeClass("header_active")
    $(".intro-four").addClass("header_active")
  	this.router.navigateByUrl('/introduction/four-element')
  }
  courseButtonClick(){
    $(".header_active").removeClass("header_active")
    $(".intro-ecourse").addClass("header_active")
  	this.router.navigateByUrl('/introduction/ecourse')
  }
  homeButtonClick(){
  	this.router.navigateByUrl('/home')
  }
  logoutClick(){
    localStorage.setItem('editmode', '0');
    this.router.navigateByUrl('/login')
  }
  profileClick(){
    this.router.navigateByUrl('/profile')
  }
  profileIconClick(){
    $('.dropdown-content').slideToggle(400, 'swing');
  }
  register1Click(){
      this.router.navigateByUrl('/register')
  }
  feedbackClick(){
      this.router.navigateByUrl('/feedback')
  }
  manageTeamClick(){
    this.router.navigateByUrl('/manage-team')
  }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts